import api from "./api";
import func from "./func";
import ImageBlobReduce from "image-blob-reduce";

const reduce = ImageBlobReduce();

let osses = [];

function oss(id, memberId) {
	let key = `${id}.${memberId}`;
	if (!func.isDefined(osses[key]))
		osses[key] = api.v1.album.photo.oss(id, memberId, 100);
	return osses[key];
}

export default {
	/**
	 * 相册图片上传
	 * @param id 相册ID
	 * @param memberId 成员ID
	 * @param data 图片内容
	 * @param params 上传参数
	 * @param opts 阿里云SDK配置
	 * @returns Promise<*>
	 */
	async upload(id, memberId, data, params, opts) {
		let suffix = params.file_name.split(".").pop();
		return (await oss(id, memberId)).multipartUpload(suffix, data, params, opts);
	},
	/**
	 * 图片压缩
	 * @param file
	 * @param long
	 * @returns {Sharp}
	 */
	resize(file, long) {
		if (func.isDefined(window.sharp))
			return window.sharp(file, long, long === 0 ? 100 : 92);
		else if (long === 0) return reduce.toBlob(file, {quality: 1});
		else return reduce.toBlob(file, {max: long, quality: 0.92});
	}
}
